﻿const main = document.querySelector('main');

export function scrollToTop() {
    main.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

export function scrollToBottom() {
    main.scrollTo({
        top: main.scrollHeight,
        behavior: 'smooth'
    });
}